
const BoxIco = ({fill}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8254 10.4062L11.318 11.3531L10.9708 11.0058L10.4736 11.503L11.4906 12.52L12.4451 10.7383L11.8254 10.4062Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1 4.11864L7.99999 1.92157L1.89999 4.11864V11.8314L8.00002 14.0285L9.72066 13.4085C10.1857 13.821 10.7974 14.0721 11.4667 14.0721C12.8928 14.0721 14.0576 12.9332 14.0996 11.5171L14.1 4.11864ZM6.5983 3.38636L7.99999 2.8815L12.3188 4.437L10.9186 4.94378L6.5983 3.38636ZM7.99999 6.00022L3.68123 4.437L5.26616 3.86616L9.58981 5.42478L7.99999 6.00022ZM2.80312 11.1968V5.07963L7.54843 6.79723V12.9059L2.80312 11.1968ZM8.45156 12.9058V6.79723L13.1969 5.07963V9.45323C12.7339 9.0491 12.1284 8.80379 11.4667 8.80379C10.0141 8.80379 8.83255 9.98537 8.83255 11.438C8.83255 11.8787 8.9415 12.2946 9.13373 12.6601L8.45156 12.9058ZM9.73567 11.438C9.73567 10.4836 10.5123 9.70691 11.4667 9.70691C12.4099 9.70691 13.179 10.4656 13.1969 11.4046V11.4713C13.179 12.4104 12.4099 13.169 11.4667 13.169C10.5123 13.169 9.73567 12.3924 9.73567 11.438Z"
        fill={fill}
      />
    </svg>
  );
};

export default BoxIco;
